import objectPath from 'object-path'

const getRuleShowLoadUITarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    'layout'
  )
}

export const onRuleShowLoadUI = (
  designContext = {},
  action = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let targetKey = getRuleShowLoadUITarget(action, target)

  objectPath.set(isUiChanged, ['isStartCallAPI', targetKey], true)
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    isStartCallAPI: true,
  }
}
